import { render, staticRenderFns } from "./RewardTableComponent.vue?vue&type=template&id=68eeb178&"
import script from "./RewardTableComponent.vue?vue&type=script&lang=js&"
export * from "./RewardTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports